export const GET_SPACE_TYPE_DATA_REQUEST = "GET_SPACE_TYPE_DATA_REQUEST";
export const GET_SPACE_TYPE_DATA_SUCCESS = "GET_SPACE_TYPE_DATA_SUCCESS";
export const GET_SPACE_TYPE_DATA_FAILURE = "GET_SPACE_TYPE_DATA_FAILURE";

export const UPDATE_SPACE_TYPE_REQUEST = "UPDATE_SPACE_TYPE_REQUEST";
export const UPDATE_SPACE_TYPE_SUCCESS = "UPDATE_SPACE_TYPE_SUCCESS";
export const UPDATE_SPACE_TYPE_FAILURE = "UPDATE_SPACE_TYPE_FAILURE";

export const ADD_SPACE_TYPE_REQUEST = "ADD_SPACE_TYPE_REQUEST";
export const ADD_SPACE_TYPE_SUCCESS = "ADD_SPACE_TYPE_SUCCESS";
export const ADD_SPACE_TYPE_FAILURE = "ADD_SPACE_TYPE_FAILURE";

export const DELETE_SPACE_TYPE_REQUEST = "DELETE_SPACE_TYPE_REQUEST";
export const DELETE_SPACE_TYPE_SUCCESS = "DELETE_SPACE_TYPE_SUCCESS";
export const DELETE_SPACE_TYPE_FAILURE = "DELETE_SPACE_TYPE_FAILURE";

export const UPDATE_SPACE_TYPE_ENTITY_PARAMS_SUCCESS = "UPDATE_SPACE_TYPE_ENTITY_PARAMS_SUCCESS";
export const UPDATE_SPACE_TYPE_ENTITY_PARAMS_FAILURE = "UPDATE_SPACE_TYPE_ENTITY_PARAMS_FAILURE";

export const GET_SPACE_TYPE_LOGS_REQUEST = "GET_SPACE_TYPE_LOGS_REQUEST";
export const GET_SPACE_TYPE_LOGS_SUCCESS = "GET_SPACE_TYPE_LOGS_SUCCESS";
export const GET_SPACE_TYPE_LOGS_FAILURE = "GET_SPACE_TYPE_LOGS_FAILURE";

export const DELETE_SPACE_TYPE_LOG_REQUEST = "DELETE_SPACE_TYPE_LOG_REQUEST";
export const DELETE_SPACE_TYPE_LOG_SUCCESS = "DELETE_SPACE_TYPE_LOG_SUCCESS";
export const DELETE_SPACE_TYPE_LOG_FAILURE = "DELETE_SPACE_TYPE_LOG_FAILURE";

export const RESTORE_SPACE_TYPE_LOG_REQUEST = "RESTORE_SPACE_TYPE_LOG_REQUEST";
export const RESTORE_SPACE_TYPE_LOG_SUCCESS = "RESTORE_SPACE_TYPE_LOG_SUCCESS";
export const RESTORE_SPACE_TYPE_LOG_FAILURE = "RESTORE_SPACE_TYPE_LOG_FAILURE";
